export default "__VITE_ASSET__7n_hhvLF__ 720w";